var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVoucher(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Voucher",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 21.389,
    viewBox: "0 0 30 21.389",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_2146483650336"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38181",
    "data-name": "Path 38181",
    d: "M15,0H28.333A1.556,1.556,0,0,1,30,1.389V3.056h-.556c-.278,0-.833.278-.833.556h0a.887.887,0,0,0,.833.833H30V6.389h-.556a.887.887,0,0,0-.833.833h0a1.252,1.252,0,0,0,.833.833H30V9.722h-.556a1.252,1.252,0,0,0-.833.833h0a.887.887,0,0,0,.833.833H30v1.944h-.556a.887.887,0,0,0-.833.833h0a1.252,1.252,0,0,0,.833.833H30v1.667h-.556a1.252,1.252,0,0,0-.833.833h0a.887.887,0,0,0,.833.833H30v1.389a1.792,1.792,0,0,1-1.667,1.667H1.389A1.556,1.556,0,0,1,0,19.722V18.333H.278a.737.737,0,0,0,.833-.833h0a.887.887,0,0,0-.833-.833H0V15H.278a.887.887,0,0,0,.833-.833h0a.737.737,0,0,0-.833-.833H0V11.389H.278a.737.737,0,0,0,.833-.833h0a.887.887,0,0,0-.833-.833H0V8.056H.278a.887.887,0,0,0,.833-.833h0a.737.737,0,0,0-.833-.833H0V4.444H.278a.737.737,0,0,0,.833-.833h0c0-.278-.278-.556-.833-.556H0V1.389A1.312,1.312,0,0,1,1.389,0Zm0,20H27.222a1.418,1.418,0,0,0,1.389-1.111,1.574,1.574,0,0,1,0-2.778v-.556a1.528,1.528,0,0,1-.833-1.389,1.68,1.68,0,0,1,.833-1.667v-.278a1.68,1.68,0,0,1-.833-1.667,1.528,1.528,0,0,1,.833-1.389V8.611a1.528,1.528,0,0,1-.833-1.389,1.98,1.98,0,0,1,.833-1.667V5.278a1.68,1.68,0,0,1-.833-1.667,1.528,1.528,0,0,1,.833-1.389,1.846,1.846,0,0,0-1.389-1.111H2.778A1.271,1.271,0,0,0,1.389,2.222a2.362,2.362,0,0,1,.833,1.389A1.876,1.876,0,0,1,1.111,5.278v.278A2.284,2.284,0,0,1,2.222,7.222,1.846,1.846,0,0,1,1.111,8.611v.556a1.846,1.846,0,0,1,1.111,1.389,1.876,1.876,0,0,1-1.111,1.667V12.5a1.876,1.876,0,0,1,1.111,1.667,1.846,1.846,0,0,1-1.111,1.389v.556A1.846,1.846,0,0,1,2.222,17.5a2.362,2.362,0,0,1-.833,1.389c0,.833.556,1.111,1.389,1.111Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38182",
    "data-name": "Path 38182",
    d: "M79,7.556V8.944a.556.556,0,0,0,1.111,0V7.556a.556.556,0,0,0-1.111,0Z",
    transform: "translate(-57.056 -5.056)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38183",
    "data-name": "Path 38183",
    d: "M79,19.944V18.556c0-.556.278-.556.556-.556s.556,0,.556.556v1.389a.556.556,0,0,1-1.111,0Z",
    transform: "translate(-57.056 -13)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38184",
    "data-name": "Path 38184",
    d: "M79,28.556v1.389c0,.556.278.556.556.556s.556,0,.556-.556V28.556a.556.556,0,0,0-1.111,0Z",
    transform: "translate(-57.056 -20.222)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38185",
    "data-name": "Path 38185",
    d: "M79,40.944V39.556a.556.556,0,0,1,1.111,0v1.389a.556.556,0,0,1-1.111,0Z",
    transform: "translate(-57.056 -28.167)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38186",
    "data-name": "Path 38186",
    d: "M79,50.556v1.389a.556.556,0,0,0,1.111,0V50.556a.556.556,0,0,0-1.111,0Z",
    transform: "translate(-57.056 -36.111)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38187",
    "data-name": "Path 38187",
    d: "M79,62.944V61.556a.556.556,0,0,1,1.111,0v1.389a.556.556,0,0,1-1.111,0Z",
    transform: "translate(-57.056 -44.056)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38188",
    "data-name": "Path 38188",
    d: "M31.111,21.25a.272.272,0,0,1-.278.278H26.944V20.139h3.889l.278.278Zm-.833,6.944a.272.272,0,0,1-.278.278H26.944V22.361h3.333Zm-4.722-5.833h.833v6.111h-.833Zm-3.889,5.833V22.361H25v6.111H21.944A.272.272,0,0,1,21.667,28.194Zm-.833-7.778.278-.278H25v1.389H21.111a.272.272,0,0,1-.278-.278Zm3.611-2.222h.833a2.15,2.15,0,0,0,.278.833v.278h-.278a1.217,1.217,0,0,1-.833-.278A.521.521,0,0,1,24.444,18.194Zm1.944.833a2.15,2.15,0,0,0,.278-.833H27.5a.521.521,0,0,1,0,.833,1.217,1.217,0,0,1-.833.278h-.278Zm0,2.5h-.833V20.139h.833Zm4.444-2.222H28.056a1.262,1.262,0,0,0,0-1.389,1.343,1.343,0,0,0-1.944,0v.278l-.278-.278a1.343,1.343,0,0,0-1.944,0,1.262,1.262,0,0,0,0,1.389H21.111A1.2,1.2,0,0,0,20,20.417v.833c0,.556.556.833.833,1.111v5.833c0,.556.556.833,1.111.833H30c.556,0,1.111-.278,1.111-.833V22.361c.278-.278.833-.556.833-1.111v-.833A1.2,1.2,0,0,0,30.833,19.306Z",
    transform: "translate(-14.444 -12.639)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoucher);
export default __webpack_public_path__ + "static/media/voucher.898c610ce28add0ba78f971e59520872.svg";
export { ForwardRef as ReactComponent };